import React from "react";
import PaymentInfoETH from "./eth";
import PaymentInfoEUR from "./eur";
import PaymentInfoDASH from "./dash";


const ccalc_baserate = (baserate, conv_euro) =>
  baserate === 0 ? 1 / conv_euro : baserate;

const ccalc_value = (token, baserate, conv, conv_euro) =>
  conv * ccalc_baserate(baserate, conv_euro) * token;

export default ({ order, user }) => {
  const sum_CHF = ccalc_value(order.token,order.conversion.conv.baserate,order.conversion.conv.rate['CHF'],order.conversion.conv.rate['EUR']);
  //  console.log('CHF',sum_CHF)
  if (sum_CHF >= 10000 && !(user.KYClevel && user.KYClevel>1) ) { // >=10.000 CHF Video Ident
    return <div>Please contact <a href="team@crwdnetwork.com">team@crwdnetwork.com</a>. We need to verify additional personal information before we can receive your payment.</div>
  }
  if (sum_CHF >= 100000 && !(user.KYClevel && user.KYClevel>2) ) { // >=100.000 CHF proof of funds
    return <div>Please contact <a href="team@crwdnetwork.com">team@crwdnetwork.com</a>. We need to verify additional personal information before we can receive your payment.</div>
  }
  switch (order.currency) {
    case "EUR":
      return <PaymentInfoEUR order={order} />;
    case "DASH":
      return <PaymentInfoDASH order={order} user={{first_name: user.Identity.FirstName, last_name:user.Identity.LastName, email: user.Emails[0].Email}} />;
    case "ETH":
      return <PaymentInfoETH order={order} />;
    default:
      return (<div>Unkonwn Payment</div>)
  }
};
